module.exports = __webpack_public_path__ + "static/media/user-journal.1f3a45f1.svg";